import Vue from 'vue';
import appconst from './appconst'
class Util{
    abp:any=window.abp;
    loadScript(url:string){
        var script=document.createElement('script');
        script.type="text/javascript";
        script.src=url;
        document.body.appendChild(script);
    }
    title(title:string){
        // let appname=this.abp.localization.localize('AppName',appconst.localization.defaultLocalizationSourceName);
		let appname="YFPO";
		let page=this.abp.localization.localize(title,appconst.localization.defaultLocalizationSourceName);
		if(title=='ActiveStatistics'){
			 //window.document.title = page;
		}
		else if(title=='sessionai'){
			window.document.title=this.abp.localization.localize("AI对话",appconst.localization.defaultLocalizationSourceName);
		}
		else{
			window.document.title = appname+'--'+page;
		}
       
    }
    inOf(arr:Array<any>, targetArr:any) {
        let res = true;
        arr.forEach(item => {
            if (targetArr.indexOf(item) < 0) {
                res = false;
            }
        });
        return res;
    }
    oneOf(ele:any, targetArr:Array<any>) {
        if (targetArr.indexOf(ele) >= 0) {
            return true;
        } else {
            return false;
        }
    }
    showThisRoute (itAccess:any, currentAccess:any) {
        if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
            return this.oneOf(currentAccess, itAccess);
        } else {
            return itAccess === currentAccess;
        }
    }
    getRouterObjByName (routers:Array<any>, name?:string):any {
        if (!name || !routers || !routers.length) {
            return null;
        }
        // debugger;
        let routerObj = null;
        for (let item of routers) {
            if (item.name === name) {
                return item;
            }
            routerObj = this.getRouterObjByName(item.children, name);
            if (routerObj) {
                return routerObj;
            }
        }
        return null;
    }
    toDefaultPage (routers:Array<any>, name:string|undefined, route:any, next:any) {
        let len = routers.length;
        let i = 0;
        let notHandle = true;
        while (i < len) {
            if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
                route.replace({
                    name: routers[i].children[0].name
                });
                notHandle = false;
                next();
                break;
            }
            i++;
        }
        if (notHandle) {
            next();
        }
    }
    handleTitle (vm:any, item:any) {
        if (typeof item.meta.title === 'object') {
            return vm.$t(item.title.i18n);
        } else {
            return item.meta.title;
        }
    }
    setCurrentPath  (vm:Vue, name?:string) {
        let title = '';
        let isOtherRouter = false;
        vm.$store.state.app.routers.forEach((item:any) => {
            if (item.children.length === 1) {
                if (item.children[0].name === name) {
                    title = this.handleTitle(vm, item);
                    if (item.name === 'otherRouter') {
                        isOtherRouter = true;
                    }
										if (item.name === 'courseRouter') {
										    isOtherRouter = true;
										}
                }
            } else {
                item.children.forEach((child:any) => {
                    if (child.name === name) {
                        title = this.handleTitle(vm, child);
                        if (item.name === 'otherRouter') {
                            isOtherRouter = true;
                        }
												if (item.name === 'courseRouter') {
												    isOtherRouter = true;
												}
                    }
                });
            }
        });
        let currentPathArr = [];
        if (name === 'home') {
            currentPathArr = [
                {
                    meta:{title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home'))},
                    path: 'main/home',
                    name: 'home'
                }
            ];
        } else if (((name as string).indexOf('hide') >= 0 || isOtherRouter) && name !== 'home') {
            // currentPathArr = [
            //     {
            //         meta:{title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home'))},
            //         path: 'main/home',
            //         name: 'home'
            //     },
            //     {
            //         meta:{title: title},
            //         path: '',
            //         name: name
            //     }
            // ];
						let currentPathObj = vm.$store.state.app.routers.filter((item:any) => {
						    if (item.children.length <= 1) {
						        return item.children[0].name === name||item.name===name;
						    } else {
						        let i = 0;
						        let childArr = item.children;
						        let len = childArr.length;
						        while (i < len) {
						            if (childArr[i].name === name) {
						                return true;
						            }
						            i++;
						        }
						        return false;
						    }
						})[0];
						if (currentPathObj.children&&currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
						    currentPathArr = [
						        {
						            meta:{title: 'HomePage'},
						            path: 'main/home',
						            name: 'home'
						        }
						    ];
						} else if (currentPathObj.children&&currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
						    currentPathArr = [
						        {
						            meta:{title: 'HomePage'},
						            path: 'main/home',
						            name: 'home'
						        },
						        {
						            meta:{title: currentPathObj.meta.title},
						            path: '',
						            name: name
						        }
						    ];
						} else {
						    let childObj = currentPathObj.children.filter((child:any) => {
						        return child.name === name;
						    })[0];
						    currentPathArr = [
						        {
						            meta:{title: 'HomePage'},
						            path: 'main/home',
						            name: 'home'
						        },
						        {
						            meta:{title: currentPathObj.meta.title},
						            path: '',
						            name: ''
						        },
						        {
						            meta:{title: childObj.meta.title},
						            path: currentPathObj.path + '/' + childObj.path,
						            name: name
						        }
						    ];
						}
        } else {
            let currentPathObj = vm.$store.state.app.routers.filter((item:any) => {
                if (item.children.length <= 1) {
                    return item.children[0].name === name||item.name===name;
                } else {
                    let i = 0;
                    let childArr = item.children;
                    let len = childArr.length;
                    while (i < len) {
                        if (childArr[i].name === name) {
                            return true;
                        }
                        i++;
                    }
                    return false;
                }
            })[0];
            if (currentPathObj.children&&currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
                currentPathArr = [
                    {
                        meta:{title: 'HomePage'},
                        path: 'main/home',
                        name: 'home'
                    }
                ];
            } else if (currentPathObj.children&&currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
                currentPathArr = [
                    {
                        meta:{title: 'HomePage'},
                        path: 'main/home',
                        name: 'home'
                    },
                    {
                        meta:{title: currentPathObj.meta.title},
                        path: '',
                        name: name
                    }
                ];
            } else {
                let childObj = currentPathObj.children.filter((child:any) => {
                    return child.name === name;
                })[0];
                currentPathArr = [
                    {
                        meta:{title: 'HomePage'},
                        path: 'main/home',
                        name: 'home'
                    },
                    {
                        meta:{title: currentPathObj.meta.title},
                        path: '',
                        name: ''
                    },
                    {
                        meta:{title: childObj.meta.title},
                        path: currentPathObj.path + '/' + childObj.path,
                        name: name
                    }
                ];
            }
        }
        vm.$store.commit('app/setCurrentPath', currentPathArr);
    
        return currentPathArr;
    }
    openNewPage (vm:Vue, name:string|undefined, argu?:any, query?:any) {
        let pageOpenedList = vm.$store.state.app.pageOpenedList;
        let openedPageLen = pageOpenedList.length;
        let i = 0;
        let tagHasOpened = false;
        while (i < openedPageLen) {
            if (name === pageOpenedList[i].name) { // 页面已经打开
                vm.$store.commit('app/pageOpenedList', {
                    index: i,
                    argu: argu,
                    query: query
                });
                tagHasOpened = true;
                break;
            }
            i++;
        }
        if (!tagHasOpened) {
            let tag = vm.$store.state.app.tagsList.filter((item:any) => {
                if (item.children) {
                    return name === item.children[0].name;
                } else {
                    return name === item.name;
                }
            });
            tag = tag[0];
            if (tag) {
                tag = tag.children ? tag.children[0] : tag;
                if (argu) {
                    tag.argu = argu;
                }
                if (query) {
                    tag.query = query;
                }
                vm.$store.commit('app/increateTag', tag);
            }
        }
        vm.$store.commit('app/setCurrentPageName', name);
    }
    fullscreenEvent (vm:Vue) {
        vm.$store.commit('app/initCachepage');
        // 权限菜单过滤相关
        vm.$store.commit('app/updateMenulist');
        // 全屏相关
    }
    extend(...args:any[]) {
        let options, name, src, srcType, copy, copyType, copyIsArray, clone,
        target = args[0] || {},
        i = 1,
        length = args.length,
        deep = false;
        if ( typeof target === 'boolean') {
            deep = target;
            target = args[i] || {};
            i++;
        }
        if ( typeof target !== 'object' && typeof target !== 'function') {
            target = {};
        }
        if ( i === length) {
            target = this;
            i--;
        }
        for ( ; i < length; i++ ) {
            if ( (options = args[i]) !== null ) {
                for ( name in options ) {
                    src = target[name];
                    copy = options[name];
                    if ( target === copy ) {
                        continue;
                    }
                    srcType = Array.isArray(src) ? 'array': typeof src;
                    if ( deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
                        if ( copyIsArray ) {
                            copyIsArray = false;
                            clone = src && srcType === 'array' ? src : [];
                        } else {
                            clone = src && srcType === 'object' ? src: {};
                        }
                        target[name] = this.extend(deep, clone, copy);
                    } else if ( copy !== undefined ) {
                        target[name] = copy;
                    }
                }
            }
        }
        return target;
    }
	date(dateString){
		dateString = dateString.substr(0, 19);
					dateString = dateString.replace(/-/g, "/").replace(/T/g, " ");
					var date = new Date(dateString);
					return date;
	}

	formatDate(date, fmt) {
			if (/(y+)/.test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
			}
			// // #ifdef APP-PLUS  
			// date.setHours(date.getHours()-8);
			// // #endif 
			let o = {
				'M+': date.getMonth() + 1,
				'd+': date.getDate(),
				'h+': date.getHours(),
				'm+': date.getMinutes(),
				's+': date.getSeconds()
			};
			for (let k in o) {
				if (new RegExp(`(${k})`).test(fmt)) {
					let str = o[k] + '';
					fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
				}
			}
			return fmt;
	}
	padLeftZero(str) {
			return ('00' + str).substr(str.length);
	}
	formatDateStr(dateString) {
					if (dateString != null && dateString.length > 0) {
						dateString = dateString.substr(0, 19);
						dateString = dateString.replace(/-/g, "/").replace(/T/g, " ");
				
						var datetime = new Date(dateString);
						var dateTimeStamp = datetime.getTime() ;
				
						var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
						var hour = minute * 60;
						var day = hour * 24;
						var week = day * 7;
						var halfamonth = day * 15;
						var month = day * 30;
						var now = new Date().getTime(); //获取当前时间毫秒
						var diffValue = now - dateTimeStamp; //时间差
				
						if (diffValue < 0) {
							console.log("diffValue<0", datetime, dateTimeStamp, now, diffValue);
							return '刚刚';
						}
						var minC = diffValue / minute; //计算时间差的分，时，天，周，月
						var hourC = diffValue / hour;
						var dayC = diffValue / day;
						var weekC = diffValue / week;
						var monthC = diffValue / month;
						var result = "";
						if (datetime.getFullYear()==new Date().getFullYear() && monthC >= 1 && monthC <= 12) {
							//result = " " + parseInt(monthC) + "月前"
							result = this.formatDate(datetime, 'MM-dd hh:mm')
						} else if (weekC >= 1 && weekC <= 4) {
							//result = " " + parseInt(weekC) + "周前"
							result = this.formatDate(datetime, 'MM-dd hh:mm')
						} else if (dayC >= 1 && dayC <= 7) {
							if(datetime.getDate() == new Date().getDate()-1){
								result = "昨天 " + this.formatDate(datetime, 'hh:mm')
							}
							else if(datetime.getDate() == new Date().getDate()-2){
								result = "前天 " + this.formatDate(datetime, 'hh:mm')
							}
							else {
								//result = " " + parseInt(dayC) + "天前"
								result = this.formatDate(datetime, 'MM-dd hh:mm')
							}
							
				
						} else if (hourC >= 1 && hourC <= 23) {
							if(datetime.getDate()==new Date().getDate()){
								result = "今天 " + this.formatDate(datetime, 'hh:mm')
							}
							else{
								result = "昨天 " + this.formatDate(datetime, 'hh:mm')
							}
							//result = " " + parseInt(hourC) + "小时前"
						} else if (minC >= 1 && minC <= 59) {
							result = " " + parseInt(minC as any) + "分钟前"
						} else if (diffValue >= 0 && diffValue <= minute) {
							result = "刚刚"
						} else {
							var datetime = new Date();
							datetime.setTime(dateTimeStamp);
							var Nyear = datetime.getFullYear(); {}
							var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
							var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
							var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
							var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
							var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
							result = Nyear + "-" + Nmonth + "-" + Ndate
						}
						return result;
				
					}
				}
				changeDate(dateA) {
					var dateee = new Date(dateA).toJSON();
					var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/,
						'');
					return date;
				}
}
const util=new Util();
export default util;